// extracted by mini-css-extract-plugin
export var dealRoom = "styles-module--dealRoom--xd5EA";
export var primary = "#06004d";
export var secondary = "#4dafd7";
export var visible = "styles-module--visible--t95A2";